import { Component } from '@angular/core';
import { IonicPage, NavController, ToastController } from 'ionic-angular';
import { APIOnLine } from "../../services/api/api.services";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { Proxy } from '../../services/proxy/proxy.service';

@IonicPage()
@Component({
  selector: 'page-incluir-jugador',
  templateUrl: 'incluir-jugador.html',
})
export class IncluirJugadorPage {

  // #region Propiedades de la página
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public filtrar: string;
  // #endregion

  constructor(
    public navCtrl: NavController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IncluirJugadorPage');
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);
    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);

    this.participantes.CargarListaParticipacion()
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {
        this.filtrar = "";
      })
      .catch(error => console.error(error));

  }

  // #region Métodos del controlador

  public Seleccionar(licencia: Proxy.PrPersonaAlineable): void {
    this.participantes.MarcarComoAlineado(licencia);
    this.navCtrl.pop();
  }

  // #endregion

}



// WEBPACK FOOTER //
// ./src/pages/incluir-jugador/incluir-jugador.ts